import Montenegro from "./me";
import English from "./en";
import Russia from "./ru";
import Ukraine from "./ua";
import Albania from "./al";
import Turkey from "./tr";
import Denmark from "./de";

const IconLangMaps = {
  me: Montenegro,
  en: English,
  ru: Russia,
  ua: Ukraine,
  al: Albania,
  tr: Turkey,
  de: Denmark,
};

export default IconLangMaps;
